var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00A03B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1364 31.0455V53.8693C61.1364 54.335 60.9514 54.7815 60.6221 55.1108C60.2929 55.44 59.8463 55.625 59.3807 55.625H20.7557C20.29 55.625 19.8435 55.44 19.5142 55.1108C19.185 54.7815 19 54.335 19 53.8693V31.0455L40.0682 17L61.1364 31.0455Z",
    stroke: "#00A03B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2301 43.335L19.5488 55.1191",
    stroke: "#00A03B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5876 55.1191L43.9062 43.335",
    stroke: "#00A03B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1364 31.0459L43.9073 43.3357H36.2291L19 31.0459",
    stroke: "#00A03B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/iconMail.5920ba51d0a34b8fc9b0043645ee5cc3.svg";
export { ForwardRef as ReactComponent };